export default __webpack_public_path__ + "static/media/noun-client2.8295f745.svg";